import React from 'react'

function RemarkModal({icon, message, onClose}) {
  return (
        <div className="modal-backdrop remark-modal">
          <div className="modal-content">
            <button className="remark-close" onClick={onClose}>&times;</button>
            <div className="modal-check modal-icon">
            <img src={icon} alt="icon"/>
            </div>
            <p className="modal-message">
              Remark
            </p>

            <p className="modal-submessage">
              {message}
            </p>
            {/* <button className="modal-button" onClick={onSubmit}>
              {buttonText}
            </button> */}
          </div>
          
        </div>
  )
}

export default RemarkModal;